import React from 'react';
import { Result, Button } from 'antd';

const NotFound: React.FC = () => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Die Seite konnte nicht gefunden werden oder ist nicht für Sie freigeschaltet."
      extra={
        <Button type="primary" href="/">
          Dashboard
        </Button>
      }
    />
  );
};

export default NotFound;
